import { reactive, toRef, toRefs, toRaw, watch, nextTick } from 'vue'
/**
 * @param props
 * @param dataFn 数据格式化
 * @returns
 */
export default function (tableRef: any, props: any, dataFn?: any) {
  const { api, showPagination, apiConfig } = toRaw(props)
  const tableData = toRef(props, 'tableData')
  const _apiConfig = (() => {
    const config = {
      totalPath: 'data.total',
      listPath: 'data.records',
      pageName: 'pageNum',
      limitName: 'pageSize'
    }
    return Object.assign(config, apiConfig)
  })()
  const state = reactive({
    tableCount: 0, // 总条数
    loading: false,
    tableData: [],
    apiData: null as any,
    key: Date.now()
  })

  // 格式化是否需要展开的数据 增加expandFlag noExpand 字段
  const dataFormat = (data: any) => dataFn ? dataFn(data) : data

  watch(tableData, (newValue) => {
    state.tableData = dataFormat(newValue)
  }, { deep: true })

  if (tableData.value) {
    state.tableData = dataFormat(tableData.value)
  }

  const getParams = () => {
    const { filterData, pageData } = toRaw(props)
    console.log('filterData', filterData)
    const { limit, page } = pageData
    const { limitName, pageName } = _apiConfig
    const params = { ...filterData }
    if (showPagination) {
      Object.assign(
        params,
        {
          [limitName]: limit,
          [pageName]: page
        }
      )
    }
    return params
  }

  const setData = (res: any) => {
    const { totalPath, listPath } = _apiConfig
    if (showPagination) {
      state.tableData = dataFormat(getValueByPath(res, listPath))
      state.tableCount = getValueByPath(res, totalPath)
    } else {
      state.tableData = dataFormat(getValueByPath(res, listPath))
    }
  }
  const getData = () => {
    const params = getParams()
    console.log('222', params)
    state.loading = true
    // 格式化时间，文案
    props.api(params)[params._setSite ? 'setSite' : 'then']((res: { data: { result: never[]; total: number; } }) => {
      state.loading = false
      state.apiData = res
      setData(res)
      state.key = Date.now()
      nextTick(() => {
        tableRef.value && tableRef.value.scrollTo({ top: 0, left: 0 })
      })
    }).catch((err: any) => {
      console.error(err)
      state.loading = false
    })
  }

  const clearData = () => {
    if (showPagination) {
      state.tableData = []
      state.tableCount = 0
    } else {
      state.tableData = []
    }
  }
  return {
    getData: api ? getData : undefined,
    clearData: api ? clearData : undefined,
    ...toRefs(state)
  }
}

const getValueByPath = (obj: any, path: string) => {
  let value = { ...obj }
  path.split('.').forEach((item: string | number) => {
    if (value instanceof Object && value[item] !== undefined) {
      value = value[item]
    } else {
      throw new Error(`在数据路径${path}中，${item}不存在`)
    }
  })
  return value
}
